import {
  canRevertToInherit,
  getInheritLabel,
  getScopedSettingValue,
  resolveInheritedFrom
} from '../model/settings-helpers'

/**
 * Exposes the pure settings display/inheritance helpers to the component
 * layer. Components and views must not value-import same-package `model/`
 * directly (the MVVM internal-import rule); this composable is the blessed
 * indirection per the Vue MVVM contract.
 */
export function useSettingsHelpers() {
  return {
    getScopedSettingValue,
    getInheritLabel,
    resolveInheritedFrom,
    canRevertToInherit
  }
}
